/*=========================================================================================
  File Name: moduleBedTypeState.js
  Description: BedType Module State
  ----------------------------------------------------------------------------------------
  Item Name: JHM SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {

  };
  